import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { addLocation, cardProfile } from '../api/UserRequest'
import logo from '../assests/zeeqr-black.svg'
// import zeeqrLoder from '../assests/Zeeqr Loading.gif'
import ClassicTheme from '../components/cardDetailView1/classicTheme/ClassicTheme';
import { Helmet } from "react-helmet";

import ClassicTheme1 from '../components/digitalInterfaceThemes/classicTheme/ClassicTheme'
import StandardTheme1 from '../components/digitalInterfaceThemes/standardTheme/StandardTheme'
import ModernTheme1 from '../components/digitalInterfaceThemes/modernTheme/ModernTheme'
import ClassicTheme2 from '../components/digitalInterfaceThemes/classicTheme2/ClassicTheme2'
import axios from 'axios'
import AntiqueTheme from '../components/digitalInterfaceThemes/antiqueTheme/AntiqueTheme'
import { CardContext } from '../components/store/CardContext'
import DigitalTheme1 from '../components/digitalInterfaceThemes/digital1/DigitalTheme1'
import EpicTheme from '../components/digitalInterfaceThemes/epicTheme/EpicTheme'
import IconicTheme from '../components/digitalInterfaceThemes/iconic/IconicTheme'
import IdealTheme from '../components/digitalInterfaceThemes/idealTheme/IdealTheme'
import TechTheme from '../components/digitalInterfaceThemes/techTheme/TechTheme'
import UltraTheme from '../components/digitalInterfaceThemes/ultraTheme/UltraTheme'
import VexTheme from '../components/digitalInterfaceThemes/vexTheme/VexTheme'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import GlassyTheme from '../components/digitalInterfaceThemes/glassyTheme/GlassyTheme'
import PrismTheme from '../components/digitalInterfaceThemes/prismTheme/PrismTheme'
import PeasantTheme from '../components/digitalInterfaceThemes/peasantTheme/PeasantTheme'
import AtlasTheme from '../components/digitalInterfaceThemes/atlasTheme/AtlasTheme'
import PatentTheme from '../components/digitalInterfaceThemes/patentTheme/PatentTheme'
import { useQueryClient } from '@tanstack/react-query'
import { getTapCounts, useSendTapCounts } from '../components/helpers/tapCountMutation'
import { getPlanValidation } from '../components/helpers/planValidation';
import { PlanValidationContext } from '../components/store/PlanValidationContext';
import ServiceUpdateModal from '../components/digitalInterfaceThemes/Common/ServiceUpdateModal';




const metaDecorator = require('../data/metaDecorator.json')

function CardDetailsViewPage() {
    const params = useParams()
    const [card, setCard] = useState('')
    // const [planValidation, setPlanValidation] = useState({
    //     exchangeContact: true,
    //     addToWallet: true,
    //     whatsappExchangeContact: true
    //   });
    const [pre, setPre] = useState(true)
    const [cardData, setCardData] = useContext(CardContext)
    const [planValidationData, setPlanValidationData] = useContext(PlanValidationContext)
    // console.log(planValidationData, 'planValidationData');
    
   
    
    const { i18n } = useTranslation()
   
    


    /* ----------- fetching card details and after that take location ----------- */

    useEffect(() => {

        const getDetails = async () => {
            try {
                // console.log(params.id, '11111111111');
                // console.log(liveLocation,'qwertyuio');
                const path = {
                    url: window.location.href
                }
                const { data } = await cardProfile(params.id, path)
                // console.log(data, 'dataaaaaaaaaaa');
                // console.log(data.subscription,"subscription")
              
                // console.log(data.footerText, 'dataaaaaaaaaaa');
                if (data.success) {

                    if (data?.card?.companyLogo) {

                        setTimeout(() => {
                            // console.log(preview, 'dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
                            // setPre(preview)
                            setPre(false)
                        }, 1000);
                    
                    } else {
                        setPre(false)
                    }
                    if (data.subscription) {
                        const validation = getPlanValidation(data.subscription);
                        setPlanValidationData(validation);

                        // console.log("Plan validation:", validation);
                      }
                    data.card.footerText = data?.footerText
                    // console.log(data, 'dataaaaaaaaaaa');
                    setCard(data.card)
                    cardDetails(data.card)
                    i18n.changeLanguage(data?.card?.language)
                    document.title = data.card.name
                    document.getElementsByTagName("META")[2].content = data.card.companyDesignation


                    let link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement("link");
                        link.rel = "icon";
                        document.getElementsByTagName("head")[0].appendChild(link);
                    }
                    link.href = data.card.faviconImage

                    let linkAppple = document.querySelector("link[rel~='apple-touch-icon']");
                    if (!linkAppple) {
                        linkAppple = document.createElement("link");
                        linkAppple.rel = "apple-touch-icon";
                        document.getElementsByTagName("head")[0].appendChild(linkAppple);
                    }
                    linkAppple.href = data.card.profileImage ? data.card.profileImage : 'https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg'

                    // const liveLocation = await axios.get('https://ipapi.co/json')
                    const liveLocation = await axios.get(`https://ipapi.co/json/?key=${process.env.REACT_APP_API_IPAPI_KEY}`)
                    // console.log("liveLocation",liveLocation);
                    
                    await addLocation(data.card._id, liveLocation.data)

                }
            } catch (error) {
                setPre(false)
                setCard('')
                console.log(error);
            }
        }

        const cardDetails = (data) => {
            const cardDatas = {
                cardID: data._id,
                backgroundImage: data?.backgroundImage,
                bgImg: data?.bgImg,
                bgImgType: data?.bgImgType,
                bgImgRepeat: data?.bgImgRepeat,
                profileImage: data?.profileImage,
                companyLogo: data?.companyLogo,
                personalDetails: {
                    name: data?.name,
                    companyDesignation: data?.companyDesignation,
                    companyName: data?.companyName,
                    about: data?.about,
                    aboutHeadline: data?.aboutHeadline,
                    phone: data?.phone,
                    secondaryPhone: data?.secondaryPhone,
                    email: data?.email,
                    secondaryEmail: data?.secondaryEmail,
                    nameSize: data?.nameSize,
                    designationSize: data?.designationSize,
                    credentials: data?.otherFields?.credentials,
                    credentialsSize: data?.otherFields?.credentialsSize,
                    divison: data?.otherFields?.divison,
                    divisonSize: data?.otherFields?.divisonSize,

                },
                socialMediaDetails: {
                    facebook: data?.facebook,
                    instagram: data?.instagram,
                    whatsappNumber: data?.whatsappNumber,
                    linkedin: data?.linkedin,
                    twitter: data?.twitter,
                    youtube: data?.youtube,
                    skype: data?.skype,
                    snapchat: data?.snapchat,
                    tiktok: data?.tiktok,
                    companyProfile: data?.companyProfile,
                },
                socialMedias: data?.socialMedias,
                websiteDetails: {
                    websiteName: data?.websiteName,
                    websiteUrl: data?.websiteUrl,
                },
                emailList: data?.emailList,
                phoneNumbers: data?.phoneNumbers,
                website: data?.website,
                review: data?.reviews,
                contactDetails: {
                    address: data?.address,
                    state: data?.state,
                    country: data?.country,
                    locationUrl: data?.locationUrl,
                },
                websiteImage: data?.websiteImage,
                fileName: {
                    fileName1: data?.files?.file1?.fileName,
                    fileName2: data?.files?.file2?.fileName,
                    fileName3: data?.files?.file3?.fileName,
                    fileName4: data?.files?.file4?.fileName,

                },
                files: {
                    file1: data?.files?.file1?.fileUrl,
                    file2: data?.files?.file2?.fileUrl,
                    file3: data?.files?.file3?.fileUrl,
                    file4: data?.files?.file4?.fileUrl,
                },
                highlightPhotos1: data?.highlightPhotos[0].highlightPhotos1,
                highlightPhotos2: data?.highlightPhotos[0].highlightPhotos2,
                highlightPhotos3: data?.highlightPhotos[0].highlightPhotos3,
                highlightPhotos4: data?.highlightPhotos[0].highlightPhotos4,
                highlightPhotos5: data?.highlightPhotos[0].highlightPhotos5,
                highlightPhotos6: data?.highlightPhotos[0].highlightPhotos6,
                highlightPhotos7: data?.highlightPhotos[0].highlightPhotos7,
                highlightPhotos8: data?.highlightPhotos[0].highlightPhotos8,
                vCard: data?.vCard,
                QRCode: data?.QRCode,
                checkProfile: data?.checkProfile,
                checkPfCard: data?.checkPfCard,
                checkLogo: data?.checkLogo,
                checkHighlight: data?.checkHighlight,
                SMediaPostion: data?.SMediaPostion,
                Highlightcolor: data?.colorCode,
                Textcolor: data?.textColor,
                Iconcolor: data?.iconBgColor,
                BgColor: data?.bgColor,
                BtIColor: data?.btIconColor,
                footerText: data?.footerText,
                exchangeContact: data?.exchangeContact,
                appleWallet: data?.appleWallet,
                googleWallet: data?.googleWallet,
            }


            setCardData(cardDatas)
        }

        getDetails()
    }, [params.id])

    console.log(card.theme);



    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();
    // const sendTapCounts = useSendTapCounts();
    const { mutate: sendTapCounts } = useSendTapCounts();

    const sendData = () => {
        // console.log('send data fn');
        const tapCounts = getTapCounts(queryClient);
        // console.log(tapCounts, 'tapCounts send data');

        // Function to check taps in an object or array
        const hasTaps = (data) => {
            if (Array.isArray(data)) {
                // console.log('array');
                return data.some((item) => item.taps > 0);
            } else if (typeof data === 'object' && data !== null) {
                // console.log('qwerty', data);
                // return Object.values(data).some((item) => hasTaps(item)); // Recursive check for nested objects/arrays
                return data.taps > 0 // Recursive check for nested objects/arrays
            }
            return false;
        };

        // Check if there is any data to send
        const hasDataToSend = Object.values(tapCounts).some(hasTaps);
        // console.log(hasDataToSend, 'hasDataToSend');

        if (hasDataToSend) {
            // console.log(tapCounts, 'tapCounts');
            const cardID = card._id ? card._id : params.id;

            // Send data using mutation
            sendTapCounts({ cardID, tapCounts });
        }
    };

    const navigate = useNavigate();


    useEffect(() => {
        // Interval to send data every 5 minutes
        const intervalId = setInterval(() => {
            sendData();
        }, 5 * 60 * 1000); // 5 minutes in milliseconds

        let isNavigating = false;

        // Function to handle unload event
        const handleUnload = (event) => {
            if (!isNavigating) {
                // Only send data if not navigating within the app
                // event.preventDefault();
                // event.returnValue = 'Are you sure you want to leave?';
                sendData();
            }
        };

        // Function to handle link clicks
        const handleLinkClick = () => {
            isNavigating = true;
        };

        // Function to reset navigation state on focus
        const handleFocus = () => {
            isNavigating = false;
        };

        // Attach event listeners to links
        const attachLinkListeners = () => {
            const links = document.querySelectorAll('a');
            links.forEach((link) => {
                link.addEventListener('click', handleLinkClick);
            });
            return links; // Return the links for cleanup later
        };

        // Initial attachment of link listeners
        let links = attachLinkListeners();

        // Add the beforeunload event listener
        window.addEventListener('beforeunload', handleUnload);

        // Add the focus event listener
        window.addEventListener('focus', handleFocus);

        // Handle dynamic addition of links (Optional)
        const observer = new MutationObserver(() => {
            links.forEach((link) => link.removeEventListener('click', handleLinkClick)); // Cleanup old listeners
            links = attachLinkListeners(); // Reattach to updated links
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Cleanup function to remove event listeners and clear the interval
        return () => {
            clearInterval(intervalId);
            window.removeEventListener('beforeunload', handleUnload);
            window.removeEventListener('focus', handleFocus);
            links.forEach((link) => {
                link.removeEventListener('click', handleLinkClick);
            });
            observer.disconnect(); // Disconnect the observer
        };
    }, [queryClient]);


    return (
        <div>

            {pre ?
                <div className='w-full h-screen flex items-center justify-center'>
                    {/* <img src={card?.companyLogo ? card.companyLogo : zeeqrLoder} alt="" /> */}
                    {card?.companyLogo ?
                        <img src={card.companyLogo} alt='' />
                        :
                        <Spin
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        fontSize: 60,
                                        color: 'black'
                                    }}
                                    spin
                                />
                            }
                        />
                    }
                </div>
                :
                (
                    card ?
                        (
                            // card.theme === 'classic1' ?
                            //     <ClassicTheme1 card={card} preview={'preview'} key={card._id} />
                            //     :
                            card.theme === 'classic2' || card.theme === 'classic1' || card.theme === 'classic' ?
                                <ClassicTheme2 card={card}   preview={'preview'} key={card._id} />
                                :
                                card.theme === 'standard1' ?
                                    <StandardTheme1 card={card}  preview={'preview'} key={card._id} />
                                    :
                                    card.theme === 'modern1' ?
                                        <ModernTheme1 card={card}  preview={'preview'} key={card._id} />
                                        :
                                        card.theme === 'antique' ?
                                            <AntiqueTheme card={card}  preview={'preview'} key={card._id} />
                                            :
                                            card.theme === 'digital' ?
                                                <DigitalTheme1 card={card}  preview={'preview'} key={card._id} />
                                                :
                                                card.theme === 'epic' ?
                                                    <EpicTheme card={card}  preview={'preview'} key={card._id} />
                                                    :
                                                    card.theme === 'iconic' ?
                                                        <IconicTheme card={card}  preview={'preview'} key={card._id} />
                                                        :
                                                        card.theme === 'vex' ?
                                                            <VexTheme card={card}  preview={'preview'} key={card._id} />
                                                            :
                                                            card.theme === 'atlas' ?
                                                                <AtlasTheme card={card}  preview={'preview'} key={card._id} />
                                                                :
                                                                card.theme === 'ideal' ?
                                                                    <IdealTheme card={card}  preview={'preview'} key={card._id} />
                                                                    :
                                                                    card.theme === 'tech' ?
                                                                        <TechTheme card={card}  preview={'preview'} key={card._id} />
                                                                        :
                                                                        card.theme === 'ultra' ?
                                                                            <UltraTheme card={card}  preview={'preview'} key={card._id} />
                                                                            :
                                                                            card.theme === 'glassy' ?
                                                                                <GlassyTheme card={card}  preview={'preview'} key={card._id} />
                                                                                :
                                                                                card.theme === 'prism' ?
                                                                                    <PrismTheme card={card}  preview={'preview'} key={card._id} />
                                                                                    :
                                                                                    card.theme === 'peasant' ?
                                                                                        <PeasantTheme card={card}  preview={'preview'} key={card._id} />
                                                                                        :
                                                                                        card.theme === 'patent' ?
                                                                                            <PatentTheme card={card}  preview={'preview'} key={card._id} />
                                                                                            :
                                                                                            <ClassicTheme2 card={card} key={card._id} />
                        )

                        :
                        <div className='w-full h-screen flex flex-col items-center justify-center'>
                            <img src={logo} alt="" />
                            <h1 className='font-bold mt-2'>This card is not valid/card has expired!</h1>
                            <p className='mt-1'>Please contact the admin</p>
                            <Link to={'https://wa.me/+971505363704?text=Hi%2C'} target="blank" >
                                <button className='p-2 mt-3 border-2 rounded-xl border-black'>Get In Touch</button>
                            </Link>

                        </div>

                )
            }
            <Helmet>
                <meta charSet="utf-8" />
                <title>{card?.name}</title>
                <meta name="description" content={card?.companyDesignation} />
                <link rel="icon" type="image/png" sizes="32x32" href={card.profileImage} />
                <link rel="icon" type="image/png" sizes="16x16" href={card.profileImage} />
                <meta property="og:title" class="notranslate" content={card.name} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={metaDecorator.hostname + window.location.pathname + window.location.search} />
                <meta property="og:description" class="notranslate" content={card.companyDesignation} />
                <meta property="og:image" content={card.profileImage} />
            </Helmet>
        </div>
    )
}

export default CardDetailsViewPage